import React, { useState } from "react";
import { P_Props } from "./LoginForm.type";
import { Form, Field } from "react-final-form";
import { InputAdornment, IconButton, TextField } from "@material-ui/core";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon, ArrowBack } from "@material-ui/icons";
import { Loading } from "../../components";
import WisereLogo from "../../../assets/images/wisere-logo.png";
import Cover from "../../../assets/images/cover.png";
import { FormUtil, loadCallback } from "../../../utils";
import { PasswordForm } from "../../containers";

const LoginFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const [visiblePassword, setVisiblePassword] = useState<boolean>(false);
  const [visibleForgotPassword, setVisibleForgotPassword] = useState<boolean>(false);

  const toggleVisiblePassword = () => {
    setVisiblePassword(!visiblePassword);
  };

  const handleClickShowForgotPassword = () => {
    setVisibleForgotPassword(!visibleForgotPassword);
  };

  return (
    <>
      <div className="login-form">
        <div className="login-form__left">
          {visibleForgotPassword ? (
            <div className="login-form__header">
              <div className="login-form__back" onClick={handleClickShowForgotPassword}>
                <ArrowBack style={{ fontSize: "3rem" }} />
              </div>
              <img src={WisereLogo} alt="wisere" style={{ paddingTop: "0rem" }} />
            </div>
          ) : <img src={WisereLogo} alt="wisere" style={{ paddingTop: "6rem" }} />}

          {props.loading && <Loading />}
          {!props.loading && !visibleForgotPassword && (
            <div className="login-form__inner">
              <div className="login-form__title">Log in to account</div>
              {/* <div className="login-form__subtitle">New to Wisere? <span>Create new account</span></div> */}

              {/* <div class="ant-divider ant-divider-horizontal ant-divider-with-text ant-divider-with-text-center" role="separator" style="color: rgb(82, 89, 96);"><span className="ant-divider-inner-text">or</span></div> */}
              <div className="login-form__container">
                {props.loading && <Loading />}
                {!props.loading && (
                  <Form
                    initialValuesEqual={() => true}
                    onSubmit={async (values, form) => {
                      props.onSignin(values);
                    }}
                    render={({ handleSubmit, form, pristine }) => {
                      submit = handleSubmit;
                      return (
                        <form onSubmit={handleSubmit} className="login-form-input">
                          <Field
                            name="userName"
                            validate={FormUtil.Rule.required("Please input username")}
                          >
                            {({ input, meta, ...rest }) => {
                              return (
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Username"
                                  variant="outlined"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                />
                              );
                            }}
                          </Field>

                          <Field name="password" validate={FormUtil.Rule.required("Please input password")}>
                            {({ input, meta, ...rest }) => {
                              return (
                                <TextField
                                  {...input}
                                  {...rest}
                                  fullWidth
                                  placeholder="Password"
                                  variant="outlined"
                                  className="form-text-field"
                                  inputProps={{ className: "input" }}
                                  onChange={(e) => input.onChange(e.target.value)}
                                  helperText={meta.touched ? meta.error : ""}
                                  error={meta.error && meta.touched}
                                  InputProps={{
                                    type: visiblePassword ? "text" : "password",
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton onClick={toggleVisiblePassword}>
                                          {visiblePassword ? (
                                            <VisibilityIcon style={{ fontSize: "2rem" }} />
                                          ) : (
                                            <VisibilityOffIcon style={{ fontSize: "2rem" }} />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              );
                            }}
                          </Field>

                          <div 
                            className="login-form__title__forgotpw" 
                            // tắt quên mật khẩu
                            // onClick={handleClickShowForgotPassword}
                          >
                            Forgot password?
                          </div>
                          <button
                            className="login-form__btn-login"
                            onClick={(e) => {
                              e.preventDefault();
                              loadCallback(submit, e);
                            }}
                          >
                            Log in
                          </button>
                        </form>
                      );
                    }}
                  />
                )}
              </div>
            </div>
          )}
          {!props.loading && visibleForgotPassword && <PasswordForm />}
          <div className="login-form__provision">
            *By Signing in, you agree to our&nbsp;
            <span className="login-form__provision__link">Terms of Use</span>&nbsp;&&nbsp;
            <span className="login-form__provision__link">Privacy Policy</span>
          </div>
        </div>
        <div className="login-form__right">
          <img src={Cover} alt="cover" />
        </div>
      </div>
    </>
  );
};

export default LoginFormPresenter;
